<template>
  <SideModal
    :show="show"
    @update:show="$emit('update:show', $event)"
    close-on-overlay-click
    location="left"
    data-cy="add-event-day-modal"
  >
    <div class="modal-top py-1">
      <span class="modal-title">Add Event Day</span>
      <v-btn @click="$emit('update:show', false)" icon size="large">
        <v-icon>mdi-close</v-icon>
      </v-btn>
    </div>

    <div class="d-flex flex-column gap-4 m-5">
      <date-picker
        color="primary"
        :model-value="new Date(state.start)"
        @update:model-value="state.start = dayjs($event).format(`YYYY-MM-DD HH:mm:ss`)"
        class="custom-input date"
        density="compact"
        type="date"
        label="Date"
        data-cy="add-event-day-date"
      ></date-picker>
      <date-picker
        color="primary"
        :model-value="new Date(state.start)"
        @update:model-value="state.start = dayjs($event).format(`YYYY-MM-DD HH:mm:ss`)"
        class="custom-input date"
        density="compact"
        type="time"
        label="Start"
        data-cy="add-event-day-start-time"
      ></date-picker>
      <date-picker
        color="primary"
        :model-value="new Date(state.end)"
        @update:model-value="state.end = dayjs($event).format(`YYYY-MM-DD HH:mm:ss`)"
        class="custom-input date"
        density="compact"
        type="time"
        label="End"
        data-cy="add-event-day-end-time"
      ></date-picker>
      <v-text-field
        color="primary"
        class="custom-input number"
        density="compact"
        type="number"
        :model-value="state.time_interval"
        @update:model-value="
          if ((+$event || +$event === 0) && +$event >= 0) state.time_interval = +$event;
        "
        label="Time Interval"
        data-cy="add-event-day-interval"
      ></v-text-field>
      <div class="mt-3 d-flex justify-end">
        <v-btn :loading="state.loadingAdd" @click="add" data-cy="add-event-day-save-btn">Add</v-btn>
      </div>
    </div>
  </SideModal>
</template>

<script setup lang="ts">
import type { ConferenceDay } from "@/api_types/teacher";
import DatePicker from "@/components/datePicker.vue";
import SideModal from "@/components/sideModal.vue";
import FetchService from "@/services/fetch.service";
import { useConferenceStore } from "@/stores/teacher/conference";
import dayjs from "dayjs";
import { cloneDeep } from "lodash";
import { reactive } from "vue";
defineProps<{
  show: boolean;
}>();

const emit = defineEmits<{
  (e: 'update:show', ...args: any[]): void
}>();

const state = reactive({
  start: dayjs().format(`YYYY-MM-DD HH:mm:ss`),
  end: dayjs().format(`YYYY-MM-DD HH:mm:ss`),
  time_interval: 5,
  loadingAdd: false
});

const confStore = useConferenceStore();

const add = async () => {
  state.loadingAdd = true;
  const end = dayjs(state.end);
  const res = await FetchService.fetchData("/conference-days", "post", {
    start: dayjs(state.start).set("seconds", 0).format(`YYYY-MM-DD HH:mm:ss`),
    end: dayjs(state.start)
      .set("hours", end.hour())
      .set("minutes", end.minute())
      .set("seconds", 0)
      .format(`YYYY-MM-DD HH:mm:ss`),
    time_interval: state.time_interval,
    conference_id: confStore.selected!.conference_id,
    meeting_types: {
      in_person: true,
      virtual: true,
      callback: false,
      phone: false,
      virtual_type: "url"
    }
  } as Partial<ConferenceDay>);
  if (res?.conference_days_id) {
    confStore.updatedConference(confStore.selected!.conference_id, {
      conference_days: [...confStore.selected!.conference_days, cloneDeep(res)]
    });

    Object.assign(confStore.selected!, {
      conference_days: [...confStore.selected!.conference_days, cloneDeep(res)]
    });
    emit("update:show", false);
  }
  state.loadingAdd = false;
};
</script>

<style scoped lang="scss">
@use "@/assets/_vars.scss" as *;
@use "@/assets/_breakpoints.scss" as breakpoints;
.modal-top {
  display: flex;
  align-items: center;
  background-color: $primary;
  min-width: 100%;
  justify-content: space-between;
  .modal-title {
    font-weight: 600;
    font-size: 1.15rem;
    margin: auto 0 auto 20px;
    color: white;
  }
}
</style>
